import ApiBase from "./base";
import { jsonToQueryString } from '../shared/utils';

export const _USER_URL = "message";

export async function list(params) {
    const response = await ApiBase.get(`${_USER_URL}?${jsonToQueryString(params)}`);

    return response;
}

export async function listUnread() {
    const response = await ApiBase.get(`${_USER_URL}/unread`);

    return response;
}

export async function listLatestMsg() {
    const response = await ApiBase.get(`${_USER_URL}/latest-msg`);

    return response;
}